import React from "react";
import IconServiceFood from "../components/UI/Icons/services/IconServiceFood";
import IconServiceRent from "../components/UI/Icons/services/IconServiceRent";
import IconServiceSki from "../components/UI/Icons/services/IconServiceSki";
import IconServiceMedical from "../components/UI/Icons/services/IconServiceMedical";
import IconServiceSkating from "../components/UI/Icons/services/IconServiceSkating";
import TrackTypeBlueIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeBlueIcon";
import TrackTypeRedIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeRedIcon";
import TrackTypeBlackIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeBlackIcon";
import TrackTypeGreenIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeGreenIcon";
import TrackTypeLightIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeLightIcon";
import TrackTypeSleighIcon from "../components/UI/Icons/LegendTrackTypes/TrackTypeSleighIcon";
import LearningAreaIcon from "../components/UI/Icons/LegendTrackTypes/LearningAreaIcon";

export const legendServicesArray = [
   {
      title: 'заклади харчування',
      key: 'showFoodMarkers',
      iconComponent: <IconServiceFood/>
   },
   {
      title: 'прокат спорядження',
      key: 'showRentMarkers',
      iconComponent: <IconServiceRent/>
   },
   {
      title: 'лижні школи',
      key: 'showSkiMarkers',
      iconComponent: <IconServiceSki/>
   },
   {
      title: 'медпункт',
      key: 'showMedicalMarkers',
      iconComponent: <IconServiceMedical/>
   },
   {
      title: 'ковзанка',
      key: 'showSkatingMarkers',
      iconComponent: <IconServiceSkating/>
   },
];

export const legendTrackTypes = [
   {
      title: 'прості траси',
      icon: <TrackTypeBlueIcon/>
   },
   {
      title: 'траси середньої складності',
      icon: <TrackTypeRedIcon/>
   },
   {
      title: 'складні траси',
      icon: <TrackTypeBlackIcon/>
   },
   {
      title: 'навчальні траси',
      icon: <TrackTypeGreenIcon/>
   },
   {
      title: 'освітлення',
      icon: <TrackTypeLightIcon/>
   },
   {
      title: 'санна траса',
      icon: <TrackTypeSleighIcon/>
   },
   {
      title: 'навчальні майданчики',
      icon: <LearningAreaIcon/>
   },
];